import { useMutation } from "react-query";
import { editInvoice } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useEditInvoice = () => {
  return useMutation(editInvoice);
};
